import script from "./DrawingToolModeControls.vue?vue&type=script&setup=true&lang=js"
export * from "./DrawingToolModeControls.vue?vue&type=script&setup=true&lang=js"

import "./DrawingToolModeControls.vue?vue&type=style&index=0&id=04b9cbcd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04b9cbcd"]])

export default __exports__